getExperiment = require 'app/scripts/lib/experiments/simple-test'
t = require('app/scripts/views/internal/teacup-with-helpers')('filter_cards')

module.exports = ->
  t.input '.js-input.js-autofocus', { type: 'text', attr: 'title', value: t.mustacheVar('title'), style: 'margin-bottom: 0;' }

  t.div '.js-filter-search-results'
